<template>
    <div
        class="horizontal grow gallery-container"
        style="min-width: 800px; width: 70vw; height: 70vh"
    >
        <div id="info-container">
            <div>
                <p class="section-title">
                    {{ $t("ADD_SYSTEMS_TO_SERVER") }}: {{ server.name }}
                </p>
                <div style="max-height: 60vh; overflow: auto">
                    <ejs-grid
                        ref="selectedGrid"
                        height="100%"
                        width="100%"
                        :dataSource="selectedSystems"
                        :selectionSettings="{ type: 'Single' }"
                        :dataBound="dataBoundSelected"
                        :allowSorting="true"
                        :editSettings="{
                            allowEditing: true,
                            allowAdding: true,
                            mode: 'Normal',
                        }"
                        :toolbar="toolbar"
                    >
                        <e-columns>
                            <e-column
                                field="name"
                                :headerText="$t('Name')"
                                textAlign="Left"
                                :isPrimaryKey="true"
                            />
                            <e-column
                                field="herdIdentifier"
                                :headerText="$t('HerdIdentifier')"
                                textAlign="Left"
                                :edit="numericParams"
                            />
                            <e-column
                                field="producerNumber"
                                :headerText="$t('ProducerNumber')"
                                textAlign="Left"
                                :edit="numericParams"
                            />
                            <e-column
                                field="clientId"
                                :headerText="$t('ClientId')"
                                textAlign="Left"
                            />
                        </e-columns>
                    </ejs-grid>
                    <div>
                        <div class="error" v-if="error != ''">{{ error }}</div>
                    </div>
                </div>
            </div>
            <div style="align-self: center">
                <Button
                    :title="$t('Save')"
                    buttonClass="save-button semi-bold"
                    style="width: 300px; align-self: center"
                    @onClick="save"
                ></Button>
            </div>
        </div>
        <div id="systems-container" style="display: block">
            <h4 style="padding-top: 10px">{{ $t("Systems") }}</h4>
            <div
                style="
                    height: 90%;
                    width: 90%;
                    margin: auto;
                    padding: 0 0 10px 0;
                "
            >
                <ejs-grid
                    ref="modal_grid"
                    height="100%"
                    width="100%"
                    :selectionSettings="{ type: 'Multiple' }"
                    :allowTextWrap="true"
                    :textWrapSettings="{ wrapMode: 'Content' }"
                    :dataBound="dataBound"
                    :dataSource="systems"
                    :showBusyIndicator="true"
                    :rowSelected="selectionChanged"
                    :rowDeselected="selectionChanged"
                >
                    <e-columns>
                        <e-column
                            type="checkbox"
                            width="50"
                            headerText="Discontinued"
                        ></e-column>
                        <e-column
                            field="name"
                            :headerText="$t('Name')"
                            textAlign="Left"
                        ></e-column>
                    </e-columns>
                </ejs-grid>
            </div>
        </div>
    </div>
</template>

<script>
import Button from "../Button.vue";
import { getSystemsAvailableForCloud, assignServerSystem } from "../../api/api";

import {
    Sort,
    Page,
    Filter,
    Toolbar,
    Search,
    CommandColumn,
    Edit,
} from "@syncfusion/ej2-vue-grids";

export default {
    props: {
        server: {
            typeof: Object,
            required: true,
        },
    },
    provide: {
        grid: [Sort, Page, Filter, Toolbar, Search, CommandColumn, Edit],
    },
    components: {
        Button,
    },
    data() {
        return {
            systems: [],
            selectedSystems: [],
            error: "",
            numericParams: { params: { decimals: 0, value: 0 } },
            toolbar: ["Edit", "Update", "Cancel"],
        };
    },
    methods: {
        async getData() {
            var result = await getSystemsAvailableForCloud();
            this.systems = result.sort(this.sortSystemsByName);
        },
        sortSystemsByName(a, b) {
            return a.name.localeCompare(b.name, undefined, {
                numeric: true,
                sensitivity: "base",
            });
        },
        selectionChanged() {
            var selection = this.$refs.modal_grid.getSelectedRecords();
            this.selectedSystems = selection;
        },
        dataBound: function () {
            this.$refs.modal_grid.autoFitColumns();
        },
        dataBoundSelected: function () {
            this.$refs.selectedGrid.autoFitColumns();
        },
        async save() {
            var toSend = {
                serverId: this.server.id,
                systemInfo: [],
            };

            this.selectedSystems.forEach((el) => {
                toSend.systemInfo.push({
                    systemId: el.id,
                    herdIdentifier: el.herdIdentifier,
                    producerNumber: el.producerNumber,
                    clientId: el.clientId,
                });
            });

            await assignServerSystem(toSend);

            this.$emit("save");
        },
    },
    mounted: async function () {
        await this.getData();
    },
};
</script>

<style scoped>
.error {
    text-align: left !important;
    color: #fd8282;
    font-size: 11px;
    font-weight: bold;
    font-family: "Open Sans", sans-serif !important;
    font-style: normal !important;
    font-weight: 400 !important;
}

#info-container {
    /* width: 50%; */
    padding: 20px;

    background: #ffffff;
    border: 1px solid #efefef;
    box-sizing: border-box;
    box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.1);
    border-radius: 5px 0px 0px 5px;

    justify-content: space-between;
    display: flex;
    flex-direction: column;
}

.section-title {
    font-weight: bold;
}
</style>


// WEBPACK FOOTER //
// src/components/Cloud/AddCloudSystemModal.vue